import { useUrlParams } from '~/modules/artist-roster/hooks/useUrlParams';
import type { ArtistUrlParamsHook } from '~/modules/artist-roster/hooks/useUrlParams/types';

import {
  formatFiltersToUrlParams,
  parseFiltersFromUrlParams,
} from './parsers/filters';
import type { RosterFilterUrlParams } from './types';

/**
 * Hook to manage URL parameters for the roster page.
 * {@link ArtistUrlParamsHook}
 */
export function useRosterUrlParams(): ArtistUrlParamsHook<RosterFilterUrlParams> {
  return useUrlParams<RosterFilterUrlParams>(
    formatFiltersToUrlParams,
    parseFiltersFromUrlParams,
  );
}
